(function () {
var $9bb4c6e2945ade4d$var$accordions = {
    settings: {
        accordions: document.querySelectorAll('.js-accordion')
    },
    init: function() {
        this.setEvents();
    },
    setEvents: function() {
        var _this = this;
        if (!this.settings.accordions) return;
        this.settings.accordions.forEach(function(accordion, index) {
            var trigger = accordion.querySelector('.js-accordion-trigger');
            var panel = accordion.querySelector('.js-accordion-panel');
            if (!trigger || !panel) return;
            trigger.addEventListener('click', function() {
                return _this.toggle(trigger, panel);
            });
            trigger.addEventListener('keydown', function(e) {
                return _this.handleKey(e, trigger, panel);
            });
            accordion.addEventListener('mouseenter', function() {
                return _this.mouseEnter(accordion);
            });
            accordion.addEventListener('mouseleave', function() {
                return _this.mouseLeave();
            });
            accordion.addEventListener('focus', function() {
                return _this.mouseEnter(accordion);
            });
        });
    },
    toggle: function(trigger, panel) {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
    },
    handleKey: function(e, trigger, panel) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.toggle(trigger, panel);
        }
    },
    mouseEnter: function(active) {
        this.settings.accordions.forEach(function(accordion) {
            accordion.classList.toggle('accordions__item--active', accordion === active);
        });
    },
    mouseLeave: function() {
        this.settings.accordions.forEach(function(accordion) {
            accordion.classList.remove('accordions__item--active');
        });
    }
};
window.addEventListener('DOMContentLoaded', function() {
    return $9bb4c6e2945ade4d$var$accordions.init();
});

})();
//# sourceMappingURL=script.js.map
